/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath, withQuery } from './lais/httpHelpers';

class LaisMessageTemplatesAPI extends ApiClient {
  constructor() {
    super('lais_message_templates', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  create(payload) {
    return axios.post(
      this.url,
      { lais_message_template: payload },
      requestConfig()
    );
  }

  update(id, payload) {
    return axios.patch(
      resourcePath(this.url, id),
      { lais_message_template: payload },
      requestConfig()
    );
  }

  delete(id) {
    return axios.delete(resourcePath(this.url, id), requestConfig());
  }
}

export default new LaisMessageTemplatesAPI();
